import type {Resident, Room} from '@/services/graphqlHooks';

export type ResidentWithOccupiedRoom = Resident & {
  occupiedRoom?: string;
};

export const getResidentWithOccupiedRoom = (
  resident: Resident,
  rooms: Room[]
): ResidentWithOccupiedRoom => ({
  ...resident,
  occupiedRoom:
    rooms.find(room => room.id === resident.roomId)?.roomNumber || '-',
});
